import React from 'react';
import { Field, Form, FormikProps } from 'formik';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';

import { FormikInput } from '../Formik/formik-input.component';
import { PrimaryButton, SecondaryButton } from '../_ui/buttons.component';
import { FormHelperText } from '../_ui/forms.component';
import { SectionHeading, Text } from '../_ui/typography.component';
import { IOtpVerifyFields, ITwoStepOtpFormProps } from './two-step-otp-form.types';

export const TwoStepOtpForm: React.FC<ITwoStepOtpFormProps> = ({
  step, form, destination, submitError, onBack, copy,
  resendSecondsRemaining = 0, resending = false, onResend,
}) => {
  const resendDisabled = resending || resendSecondsRemaining > 0;
  const resendLabel = resending
    ? 'Sending…'
    : resendSecondsRemaining > 0
      ? `Resend code (${resendSecondsRemaining}s)`
      : 'Resend code';

  // Wipe the prior code before triggering a resend so the new SMS-autofill
  // prompt lands in an empty field — fires before the first verify attempt too.
  const handleResendClick = onResend ? () => {
    (form as FormikProps<IOtpVerifyFields>).setFieldValue('code', '');
    onResend();
  } : undefined;

  return (
    <Form>
      {step === 'request' ? (
        <>
          <SectionHeading>{copy.requestHeading}</SectionHeading>
          <Text>{copy.requestDescription}</Text>
          <Field fid="otp" name="identifier" label="Email or phone number" autoComplete="username" component={FormikInput} />
          <FormControl margin="normal" fullWidth>
            <PrimaryButton type="submit" variant="contained">
              {form.isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'Send code'}
            </PrimaryButton>
          </FormControl>
        </>
      ) : (
        <>
          <SectionHeading>Enter your code</SectionHeading>
          <Text>We sent a 6-digit code to {destination}.</Text>
          {/* autoComplete="one-time-code" is what triggers the iOS/Android SMS
              autofill suggestion bar; inputMode gives the numeric keypad. */}
          <Field
            fid="otp"
            name="code"
            label="6-digit code"
            autoComplete="one-time-code"
            inputMode="numeric"
            component={FormikInput}
          />
          <FormControl margin="normal" fullWidth>
            <PrimaryButton type="submit" variant="contained">
              {form.isSubmitting ? <CircularProgress size={20} color="inherit" /> : copy.verifySubmitLabel}
            </PrimaryButton>
          </FormControl>
          {handleResendClick && (
            <Box mt={1}>
              <SecondaryButton
                variant="text"
                type="button"
                onClick={handleResendClick}
                disabled={resendDisabled}
              >
                {resendLabel}
              </SecondaryButton>
            </Box>
          )}
          <Box mt={1}>
            <SecondaryButton onClick={onBack} variant="text">Use a different email or phone</SecondaryButton>
          </Box>
        </>
      )}
      {submitError && <FormHelperText error>{submitError}</FormHelperText>}
    </Form>
  );
};
